import { useRouter } from "next/router";
import * as C from "@components/customizing/customizingProducts/Customizing.styles";
import Link from "next/link";
import PortfolioSlider from "../PortfolioSlider";
import { priceComma } from "@/common/splicePrice";

const CustomizingHeader = ({
  isUser,
  dummyList,
  basketData,
  category,
  gallery,
  deleteBasketItem,
}) => {
  const router = useRouter();

  return (
    <>
      {router.query.code && (
        <C.HeaderTitle style={{ marginTop: "70px" }}>
          <>
            제작할{" "}
            <strong>
              {dummyList?.make_category &&
                category &&
                dummyList?.make_category[category?.code]}
            </strong>
            의 세부항목을 입력해주세요.
          </>
        </C.HeaderTitle>
      )}

      <C.CustomMobileTitle>
        <h4>세부항목 입력</h4>
      </C.CustomMobileTitle>

      <C.CustomCartWrapper new={true}>
        <div>
          <Link
            href={`/customizing/customizing-products/?type=${
              router.query.type ? router.query.type : "S"
            }`}
          >
            <a>{`${TYPE[router.query.type ? router.query.type : "S"]} `}</a>
          </Link>

          {dummyList?.make_category &&
            router.query.first &&
            dummyList?.make_category[router.query?.first] && (
              <>
                {`> `}
                <Link
                  href={`/customizing/customizing-products/?type=${
                    router.query.type ? router.query.type : "S"
                  }&first=${router.query.first}`}
                >
                  <a>{`${dummyList?.make_category[router.query?.first]} `}</a>
                </Link>
              </>
            )}

          {dummyList?.make_category &&
            router.query.code &&
            dummyList?.make_category[router.query.code] && (
              <>
                {`> `}
                <Link
                  href={`/customizing/customizing-products/new/?type=${
                    router.query.type ? router.query.type : "S"
                  }&first=${router.query.first}&code=${router.query.code}`}
                >
                  <a>{`${dummyList?.make_category[router.query.code]}`}</a>
                </Link>
              </>
            )}
        </div>

        <div className="cart">
          <span>
            {isUser
              ? ` 현재 견적 바구니에 ${
                  basketData?.Count || 0
                }개의 견적이 담겨있습니다.`
              : "로그인 시 이용 가능합니다."}
          </span>

          <div className="icon">
            <i className="fi-rs-shopping-bag" />
            <span className="bag-count">{basketData?.Count || 0}</span>
          </div>

          <div className="hover-cart">
            {basketData?.Rows?.map((el, i) => (
              <div className="cart-row" key={i}>
                <div className="cart-tumbnail">
                  <img
                    src={el.images && el.images[0] ? el.images[0] : el.image}
                  />
                  <h6>{el.name}</h6>
                </div>
                <div className="cart-info">
                  <div className="info-box">
                    <div>
                      <span>수량 :</span>
                      <span>{priceComma(el.cnt)}</span>
                    </div>
                    <div>
                      <span>단가 :</span>
                      <span>
                        {el.price === "0"
                          ? "24시간 이내 견적"
                          : priceComma(el.price) + "원"}
                      </span>
                    </div>
                    <div>
                      <span>합계 :</span>
                      <span>
                        {el.price === "0"
                          ? "24시간 이내 견적"
                          : priceComma(Number(el.cnt) * Number(el.price)) +
                            "원"}
                      </span>
                    </div>
                  </div>
                  <div className="btn-box">
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deleteBasketItem(el.id)}
                    >
                      삭제
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {!isUser ? (
              <div className="d-flex flex-column">
                <div
                  style={{
                    color: "#212529",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  로그인이 필요한 기능입니다.
                </div>
                <Link href="/login">
                  <a className="btn btn-sm">로그인</a>
                </Link>
              </div>
            ) : (
              <div className="cart-btn">
                <Link href="/customizing/customizing-cart">
                  <a className="btn btn-sm">견적 바구니로 이동</a>
                </Link>
              </div>
            )}
          </div>
        </div>
      </C.CustomCartWrapper>

      {!router.query.code && (
        <div className="flex flex-col">
          <PortfolioSlider gallery={gallery} />
        </div>
      )}
    </>
  );
};

export default CustomizingHeader;

const TYPE = {
  S: "포장재 먼저 선택하기",
  T: "포장할 제품을 먼저 선택하기",
};
